import React from "react";
import {Tabs} from 'antd';
import {ConnectedReduxProps} from "@reducers/index";
import __i18n from "../../intl/__i18n";
import StatisicInformation from "../../components/public-users/item/StatisticInformation";
import UserSubscriptions from '../../components/public-users/item/UserSubscriptions';
import UserPurchases from '../../components/public-users/item/UserPurchases';
import ContentWatchProfile from '../../components/public-users/item/ContentWatchProfile';

const {TabPane} = Tabs;


interface PropsFromState {
  loading: boolean;
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;


const PublicUserReportPage = (props: AllProps) => {
  const {id} = props.match.params;
  
  return (
    <Tabs type="card">
      <TabPane tab={__i18n("Statistic Information")} key="statistic_information">
        <StatisicInformation userId={id}/>
      </TabPane>
      
      <TabPane tab={__i18n("User Subscriptions")} key="user_subscriptions">
        <UserSubscriptions filter={{ id  }}/>
      </TabPane>
  
      <TabPane tab={__i18n("User Purchases")} key="user_purchases">
        <UserPurchases filter={{ id }}/>
      </TabPane>
      
      <TabPane tab={__i18n("Content watch profile")} key="content_watch_profile">
        <ContentWatchProfile filter={{ id  }}/>
      </TabPane>
    </Tabs>
  )
};


export default PublicUserReportPage




